class InternationalCalls {
	constructor(props) {
		let _that = this;
		_that.pills = document.querySelectorAll('#allrates .nav-link')

		_that = Object.assign(this, props);
		_that.pageEvents();
	}

	pageEvents() {
		const _that = this;
		_that.pills.forEach(pill => {
			pill.addEventListener('click', e => {
				_that.deselectAllPills();
			});
		});
	}

	deselectAllPills() {
		const _that = this;
		_that.pills.forEach(pill => {
			if (pill.classList.contains('active')) {
				pill.classList.remove('active');
			}
		});
	}
}